import React, { useEffect, useState } from 'react'
import { Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import ImgProduct from "../../../assets/Image/ImgProduct/2.png";
import "./ProductServiceStyle.css"
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnSend } from 'components/Common/Button';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { AlertTitle, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import moment from 'moment';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import AOS from "aos";
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

import GoogleMapComp from 'view/Map/GoogleMapComp';
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.FormPublicProductService.fields';
const FormPublicProductService = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout900 = useMediaQuery('(min-width:900px)');
    // const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [IsCheckTel, setIsCheckTel] = useState(false)
    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": []
    })

    const [OptionTel, setOptionTel] = useState([] as any);
    const [OptionCompany, setOptionCompany] = useState([] as any);
    const [Optionlocation, setOptionlocation] = useState([] as any);
    const [sTypeID, setsTypeID] = useState(location?.state ? location.state["sTypeID"] : null)
    const [IsAddTelExtention, setIsAddTelExtention] = useState(false)

    const [ObjData, setObjData] = useState({} as any)
    const [IsOpenMap, setIsOpenMap] = useState(false)
    const [oLocationCurrent, setoLocationCurrent] = useState({
        lat: null,
        lng: null,
    })
    const [sLocation, setsLocation] = useState({
        Latitude: null,
        Longitude: null,
        Address: null,
    })
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const schema = yup.object().shape({
        sDetail: yupFormSchemas.string(i18n(`${i18nField}.sDetail`), { required: true }),

        oCompany: yupFormSchemas.object(i18n(`${i18nField}.sCompany`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? true : false }),
        oAddress: yupFormSchemas.object(i18n(`${i18nField}.sAddress1`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? true : false }),
        oTel: yupFormSchemas.object(i18n(`${i18nField}.sTel`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? true : false }),

        sFname: yupFormSchemas.string(i18n(`${i18nField}.sFirstname`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        sLname: yupFormSchemas.string(i18n(`${i18nField}.sLastname`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: false, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: false, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        // sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: IsAddTelExtention, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sEmail: yupFormSchemas.email(i18n(`${i18nField}.sEmail`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        sCompany: yupFormSchemas.string(i18n(`${i18nField}.sCompany`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        sAddress: yupFormSchemas.string(i18n(`${i18nField}.sAddress1`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),

    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const sID = urlParams.get("sID");

        if (sID != null && location?.state) {
            GetDetailById(sID);
            GetDataInitialForm();
        }
    }, [location.search])


    const GetDetailById = (sID) => {
        if (location.state?.sTypeID == "1") {
            BlockUI()
            AxiosGet(`Product/GetProductByID`, { "sProductID": sID, "sLanguage": currentLanguage() }, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.result) {
                        setObjData(res.result || null)
                    } else {
                        navigate("/")
                    }
                })
            });
        }
        else if (location.state?.sTypeID == "2") {
            BlockUI()
            AxiosGet(`Service/GetServiceByID`, { "sServiceID": sID, "sLanguage": currentLanguage() }, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.result) {
                        setObjData(res.result || null)
                    } else {
                        navigate("/")
                    }
                })
            });
        }
        else if (location.state?.sTypeID == "3") {
            BlockUI()
            AxiosGet(`Training/GetTrainingByID`, { "sTrainingID": sID, "sLanguage": currentLanguage() }, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.result) {
                        setObjData(res.result || null)
                    } else {
                        navigate("/")
                    }
                })
            });
        }

    }

    const GetDataInitialForm = async () => {
        let nUserID = 0;
        let sUserType = "";
        let lstIntBA = [] as any;
        await AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                nUserID = res.result.nUserID;
                lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                sUserType = res.result.sUserType;
                setDataUser({
                    "nUserID": res.result.nUserID || null,
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                });
            })
        })


        if (nUserID != 0 && sUserType === "C") {
            await AxiosGet(`Customer/GetDefaultDataCustomerNoPIS`, { "nUserID": nUserID }, (res) => {
                UnBlockUI();
                ResultAPI(res, null, async () => {
                    form.setValue("oCompany", res.oDefaultCompany ?? null)
                    form.setValue("oAddress", res.oDefaultAddress ?? null)
                    form.setValue("oTel", res.oDefaultTel ?? null)

                    let nCompanyID = res?.oDefaultCompany?.value;

                    if (nCompanyID) {
                        await AxiosGet(`Company/GetCompanyAddressAll`, { "nUserID": nUserID, "nCompanyID": nCompanyID, "IsAdd": false }, (res) => {
                            ResultAPI(res, null, () => {
                                setOptionlocation(res.result.data || [])

                            })
                        });
                    }
                })
            });

            await AxiosGet(`User/GetUserTelById`, { "nUserID": nUserID, "IsAdd": false }, (res) => {
                ResultAPI(res, null, () => {
                    setOptionTel(res.result.data || [])
                })
            });

            await AxiosPost(`Company/GetCustomerCompany`, { "sLanguage": currentLanguage(), "IsAdd": false }, (res) => {
                ResultAPI(res, null, () => {
                    setOptionCompany(res.result.data || [])


                })
            });
        }
    };

    const onHandleChangeValue = async (eventValue, sField) => {
        switch (sField) {
            case "company":
                form.setValue("oAddress", null)
                form.setValue("sAddress", null)
                if (eventValue && eventValue.value) {
                    AxiosGet(`Company/GetCompanyAddressAll`, { "nUserID": DataUser.nUserID, "nCompanyID": eventValue.value, "IsAdd": false }, (res) => {
                        ResultAPI(res, null, () => {
                            setOptionlocation(res.result.data || [])
                            let chk1Option = (res.result.data || []).filter(f => f.value != "-1")
                            if (chk1Option.length === 1) {
                                form.setValue("oAddress", chk1Option[0])
                            }
                        })
                    });
                }
                break;
        }
    }

    const SaveDataVOC = () => {
        let param = {} as any;

        let sTitleTH = "";
        let sTitleEN = "";
        let sIntroduceTH = ObjData?.sIntroduce;
        let sIntroduceEN = ObjData?.sIntroduce;
        let nRefGBUWebID = 0;
        let nParentID = 0;

        switch (sTypeID) {
            case "1":
                sTitleTH = ObjData?.sProductName;
                sTitleEN = ObjData?.sProductName;
                nRefGBUWebID = ObjData?.nProductID;
                nParentID = ObjData?.nParentProductID;
                break;
            case "2":
                sTitleTH = ObjData?.sServiceName;
                sTitleEN = ObjData?.sServiceName;
                nRefGBUWebID = ObjData?.nServiceID;
                nParentID = null;
                break;
            case "3":
                sTitleTH = ObjData?.sTrainingName;
                sTitleEN = ObjData?.sTrainingName;
                nRefGBUWebID = ObjData?.nTrainingID;
                nParentID = null;
                break;

        }

        if (DataUser.nUserID === 0 || DataUser.nUserID == null) {
            param = {
                "nJobTypeID": null,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
                "sMode": "N",       //เปิดใหม่
                "nCustomerID": null,
                "cCustomerType": "P",        //E customer
                "nVOCFormTypeID": 2,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
                "sDetail": form.getValues("sDetail") ?? null,
                "sExternal_FName": form.getValues("sFname") ?? null,
                "sExternal_LName": form.getValues("sLname") ?? null,
                "sExternal_Tel": form.getValues("sInputTel") ?? null,
                "sExternal_Tel_Extension": form.getValues("sInputTelExtension") ?? null,
                "sExternal_Email": form.getValues("sEmail") ?? null,
                "sExternal_CompanyName": form.getValues("sCompany") ?? null,
                "sExternal_Address": form.getValues("sAddress") ?? null,
                "sExternal_Latitude": sLocation.Latitude ? sLocation.Latitude + "" : null,
                "sExternal_Longitude": sLocation.Longitude ? sLocation.Longitude + "" : null,
                "sIssueDate": moment().format("DD/MM/YYYY HH:mm"),
                "IsCreateVOCByBA": false,
                "IsAllowContact": IsCheckTel,
                "nSelectAddrType": 2,
                "objFormProduct": {
                    "nProductID": 0,
                    "nRefGBUWebID": nRefGBUWebID,
                    "nTypeID": parseInt(sTypeID),
                    "nParentProductID": nParentID,
                    "nLevel": null,
                    "sTitleTH": sTitleTH,
                    "sTitleEN": sTitleEN,
                    "sDescTH": sIntroduceTH,
                    "sDescEN": sIntroduceEN
                },
            }
        }
        else {
            param = {
                "nJobTypeID": null,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
                "sMode": "N",       //เปิดใหม่
                "nCustomerID": DataUser.nUserID ?? null,
                "cCustomerType": "E",        //E customer
                "nVOCFormTypeID": 2,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
                "nCompanyID": form.getValues("oCompany") ? parseInt(form.getValues("oCompany").value) : null,
                "sDetail": form.getValues("sDetail") ?? null,
                "nTelID": form.getValues("oTel") ? parseInt(form.getValues("oTel").value) : null,
                "sIssueDate": moment().format("DD/MM/YYYY HH:mm"),
                "IsCreateVOCByBA": false,
                "IsAllowContact": IsCheckTel,
                "nSelectAddrType": 2,
                "nAddrID": form.getValues("oAddress") ? parseInt(form.getValues("oAddress").value) : null,
                "objFormProduct": {
                    "nProductID": 0,
                    "nRefGBUWebID": nRefGBUWebID,
                    "nTypeID": parseInt(sTypeID),
                    "nParentProductID": nParentID,
                    "nLevel": null,
                    "sTitleTH": sTitleTH,
                    "sTitleEN": sTitleEN,
                    "sDescTH": sIntroduceTH,
                    "sDescEN": sIntroduceEN
                },
            }
        }


        let sMessage = currentLanguage() == "th" ? "คุณต้องการที่จะส่งข้อมูลใช่หรือไม่ ?" : "Do you want to send information ?";
        SwAlert.Confirm(AlertTitle.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        onClearData();
                        setIsOpenSnackbar(true);
                        let sHTML;
                        if (DataUser.nUserID === 0 || DataUser.nUserID == null) {
                            sHTML = currentLanguage() == "th" ? <><p>บันทึกข้อมูลสำเร็จ</p></> : <><p>Data is already saved.</p></>
                        }
                        else {
                            sHTML = currentLanguage() == "th" ? <><p>บันทึกข้อมูลสำเร็จ</p><p>เลขที่ใบแจ้ง: {res.result?.sVOCFormCode}</p></> : <><p>Data is already saved.</p><p>Report Number: {res.result?.sVOCFormCode}</p></>
                        }
                        setsMessageSnackbar(sHTML)
                        setsSeveritySnackbar("success")
                        setIsOpenMap(false)
                        GetDataInitialForm();
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });

                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                    }
                })
            }, (res) => {
                setIsOpenSnackbar(true);
                setsMessageSnackbar(res?.response?.data?.Message)
                setsSeveritySnackbar("warning")
            }, null)
        })

    }

    const onClearData = () => {
        setIsCheckTel(false)
        Object.keys(form.getValues()).forEach((key => {
            form.setValue(key, null);
            form.clearErrors(key);
        }))
    }

    const onSetDataAddress = (lan, lng, Address) => {
        form.setValue("sAddress", Address)
        form.clearErrors("sAddress")
        setsLocation({
            Latitude: lan,
            Longitude: lng,
            Address: Address,
        })
    }


    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>
                    <Typography style={{ lineHeight: "1", color: '#ffffff' }}>
                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.4em" : "3em" }}>
                            {i18n(`${i18nField}.sEnquireInfo`)}
                        </span>{" "}
                        <span style={{ fontWeight: "400", fontSize: !Layout900 ? "1.4em" : "3.2em" }}>
                            {i18n(`${i18nField}.sGP`)}
                        </span>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item>
                                <Link to="/Home" preventScrollReset={true}>
                                    <span style={{ fontWeight: "400", color: '#ffffff', fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                        {i18n(`${i18nField}.sHomepage`)}
                                    </span>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Divider orientation='vertical' style={{ height: '30px', backgroundColor: '#ffffff' }} />
                            </Grid>
                            <Grid item>
                                <span style={{ fontWeight: "400", fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    <b>{i18n(`${i18nField}.sMainPageVOC`)}</b>
                                </span>
                            </Grid>
                        </Grid>
                    </Typography>
                </div>
                <img src={ImgProduct} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover' }} />
            </div>
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginBottom: '1em',overflowX:'hidden' }}>
                <Grid item xs={12} md={6.5} data-aos="fade-right">
                    <div style={{ position: 'relative', padding: '2.5em 2em' }}>
                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start">
                            <Grid item xs={12} >
                                <Typography className='product-title'>
                                    {
                                        sTypeID === "1"
                                            ? <>{ObjData?.sProductName}</>
                                            : sTypeID === "2"
                                                ? <>{ObjData?.sServiceName}</>
                                                : sTypeID === "3"
                                                    ? <>{ObjData?.sTrainingName}</>
                                                    : null
                                    }
                                    {/* {ObjData?.sProductName} */}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography className='product-intro'>
                                    {
                                        Layout900
                                            ?
                                            <>
                                                {
                                                    sTypeID === "1"
                                                        ? <img src={ObjData?.sFileLink} alt={""} className='img-detail-float' data-aos="fade-right" data-aos-duration="2000" />
                                                        : sTypeID === "2"
                                                            ? <img src={ObjData?.sFileLink} alt={""} className='img-detail-float' data-aos="fade-right" data-aos-duration="2000" />
                                                            : sTypeID === "3"
                                                                ? <img src={ObjData?.sFileLink} alt={""} className='img-detail-float' data-aos="fade-right" data-aos-duration="2000" />
                                                                : null
                                                }
                                                {/* <img src={ObjData?.sFileLink} alt={""} className='img-detail-float' data-aos="fade-right" data-aos-duration="2000" />  */}
                                            </>
                                            : null
                                    }
                                    {
                                        sTypeID === "1"
                                            ? <>{ObjData?.sIntroduce}</>
                                            : sTypeID === "2"
                                                ? <>{ObjData?.sIntroduce}</>
                                                : sTypeID === "3"
                                                    ? <>{ObjData?.sIntroduce}</>
                                                    : null
                                    }
                                    {/* {ObjData?.sIntroduce} */}
                                </Typography>
                            </Grid>
                            <Grid item xs={'auto'}>
                                {!Layout900 ? <img src={ObjData?.sFileLink} alt={""} className='img-detail' data-aos="fade-right" data-aos-duration="2000" /> : null}
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                <Divider orientation="vertical" variant="middle" flexItem style={{ display: !Layout900 ? 'none' : 'block', margin: '24px 8px 4px', border: '0.5px solid #d4d4d4', backgroundColor: '#d4d4d4' }} />
                <Grid item xs={12} md={5} data-aos="fade-left">
                    <FormProvider {...form}>
                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ padding: '2.5em 2em' }}>
                            <Grid item xs={12} >
                                <Typography style={{ fontSize: '1.3em' }}>
                                    {i18n(`${i18nField}.sCI`)}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <InputCustomLabel
                                    id="sDetail"
                                    name="sDetail"
                                    label={i18n(`${i18nField}.sDetail`)}
                                    required={true}
                                    multiline={true}
                                    maxLength={1000}
                                    rows={4}
                                    fullWidth
                                />
                            </Grid>
                            {
                                DataUser.nUserID != null && DataUser.sUserType === "C"
                                    ?
                                    <Grid item xs={12} >
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                            <Grid item xs={12}>
                                                <AutoCompleteSelect
                                                    name="oCompany"
                                                    options={OptionCompany}
                                                    label={i18n(`${i18nField}.sCompany`)}
                                                    required={true}
                                                    onChange={(e) => { onHandleChangeValue(e, "company") }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <AutoCompleteSelect
                                                    name="oAddress"
                                                    options={Optionlocation}
                                                    // label={"ที่อยู่"}
                                                    label={i18n(`${i18nField}.sAddress1`)}
                                                    required={true}
                                                    onChange={(e) => { onHandleChangeValue(e, "address") }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <AutoCompleteSelect
                                                    name="oTel"
                                                    options={OptionTel}
                                                    label={i18n(`${i18nField}.sTel`)}
                                                    required={true}
                                                    onChange={(e) => { onHandleChangeValue(e, "tel") }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ marginTop: '-16px' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={IsCheckTel}
                                                            onChange={() => { setIsCheckTel(!IsCheckTel); }} />}
                                                    label={i18n(`${i18nField}.sApprove`)}
                                                    labelPlacement="end"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    :
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                            <Grid item xs={12} md={6}>
                                                <InputFormItem
                                                    id="sFname"
                                                    name="sFname"
                                                    label={i18n(`${i18nField}.sFirstname`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <InputFormItem
                                                    id="sLname"
                                                    name="sLname"
                                                    label={i18n(`${i18nField}.sLastname`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                                    <Grid item xs={12} sm={12} md={5}>
                                                        <InputFormItem
                                                            id="sInputTel"
                                                            name="sInputTel"
                                                            label={i18n(`${i18nField}.sTel`)}
                                                            required={false}
                                                            fullWidth
                                                            maxLength={10}
                                                            onChange={(e)=>{
                                                                if(e == "")
                                                                {
                                                                    setIsAddTelExtention(false);
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                    { <Grid item xs={12} sm={12} md={'auto'}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={IsAddTelExtention}
                                                                    disabled={(!form.getValues("sInputTel"))}
                                                                    onChange={() => {
                                                                        setIsAddTelExtention(!IsAddTelExtention);
                                                                        form.setValue("sInputTelExtension", null)
                                                                        form.clearErrors("sInputTelExtension")
                                                                    }}
                                                                />
                                                            }
                                                            label={i18n(`${i18nField}.sTelExtension`)}
                                                            labelPlacement="end"
                                                        />
                                                    </Grid>}
                                                    {IsAddTelExtention &&
                                                        <Grid item xs={12} sm={12} md={3}>
                                                            <InputFormItem
                                                                id="sInputTelExtension"
                                                                name="sInputTelExtension"
                                                                label={i18n(`${i18nField}.sTelExtension`)}
                                                                required={false}
                                                                fullWidth
                                                                maxLength={10}
                                                                />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <InputFormItem
                                                    id="sEmail"
                                                    name="sEmail"
                                                    label={i18n(`${i18nField}.sEmail`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ marginTop: '-16px' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={IsCheckTel}
                                                            onChange={() => { setIsCheckTel(!IsCheckTel); }} />}
                                                    label={i18n(`${i18nField}.sApprove`)}
                                                    labelPlacement="end"
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputFormItem
                                                    id="sCompany"
                                                    name="sCompany"
                                                    label={i18n(`${i18nField}.sCompany`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputFormItem
                                                    id="sAddress"
                                                    name="sAddress"
                                                    label={i18n(`${i18nField}.sAddress1`)}
                                                    required={true}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <div style={{display:'flex',justifyContent:'flex-end',alignItems:'center',gap:'4px'}}>
                                                    <span>
                                                        <AddLocationAltIcon style={{ color: '#027db4' }} />
                                                    </span>
                                                    <div
                                                        onClick={() => {
                                                            setIsOpenMap(!IsOpenMap)
                                                        }}
                                                        style={{
                                                            color: '#027db4',
                                                            cursor: 'pointer',
                                                            textDecoration: 'underline',
                                                            textAlign:'right'
                                                        }}
                                                    >
                                                        {IsOpenMap ? <Typography>{i18n(`${i18nField}.sOM`)}</Typography> : <Typography>{i18n(`${i18nField}.sCFM`)}</Typography>}
                                                    </div>
                                                </div>
                                         
                                            </Grid>
                                            {
                                                IsOpenMap
                                                    ?
                                                    <Grid item xs={12} >
                                                        <GoogleMapComp
                                                            MapHeight={"600px"}
                                                            oLocationCurrent={oLocationCurrent}
                                                            setoLocationCurrent={setoLocationCurrent}
                                                            onSetDataAddress={onSetDataAddress}
                                                        />
                                                    </Grid>
                                                    : null
                                            }
                                        </Grid>
                                    </Grid>
                            }
                            <Grid item >
                                <BtnSend txt={i18n(`${i18nField}.sSendData`)} onClick={form.handleSubmit(() => { SaveDataVOC() })} />
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default FormPublicProductService